import type { QueryClient } from '@tanstack/react-query';
import { dbClear } from '@/integrations/idb/db';
import { Sentry } from '@/integrations/sentry/sentry';
import { cancelAllRefreshSchedules } from './schedule-token-refresh';
import { broadcastSignedOut } from './session-broadcast';

export const clearAuthSession = async (
  queryClient: QueryClient,
): Promise<void> => {
  cancelAllRefreshSchedules();
  queryClient.clear();
  await dbClear();
  Sentry.setUser(null);
  broadcastSignedOut();
};
